import React from "react";
import styled from "styled-components";
import logo from "../../assets/images/logo-mobile.png";
import MessageIcon from "../icons/Message";
import SearchClose from "../icons/SearchClose";

const Container = styled.div`
  background-color: ${props => props.theme.backgroundSecondary};
  height: 11.5vh;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: "dubai-bold";
  font-size: 4.7vw;
  color: ${props => props.theme.textHighlight};
  @media (min-width: 575px) {
    display: none;
  }
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Image = styled.img`
  margin-left: 10px;
`;

const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: 0 1fr;
  width: 100%;
  margin: 0 20px;
`;
const InputField = styled.input`
  background-color: ${props => props.theme.primary};
  border: 1px solid ${props => props.theme.primary};
  padding: 5px 10px;
  height: 20px;
  border-radius: 50px;
  outline: none;
  color: ${props => props.theme.white};
  text-align: right;
  font-size: 14px;
  font-family: "dubai-regular";
  padding-left: 40px;
`;

const Icon = styled.i`
  width: 40px;
  position: relative;
  left: 15px;
  top: 9px;
  cursor: pointer;
  z-index: 1;
`;

const MobileHeader = ({ onTweetShow, isSearch, searchClose }) => {
  return (
    <Container>
      {isSearch ? (
        <InputWrapper>
          <Icon>
            <SearchClose onClick={searchClose} />
          </Icon>
          <InputField autoFocus type="text" />
        </InputWrapper>
      ) : (
        <>
          <MessageIcon onClick={() => onTweetShow(true)} />
          <Brand>
            <span>مؤشرات خدمات الجهات الحكومية</span>
            <Image src={logo} />
          </Brand>
        </>
      )}
    </Container>
  );
};

export default MobileHeader;
